import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useFormik } from 'formik';

import { _Object } from 'utils/interfaces';
import { productService } from 'services';
import {
  capitalizeFirstLetter,
  doAmountFormat,
  updateInputFieldValue,
} from 'utils';
import { addToCart, setQuantity } from 'redux/slices/cart.slice';

import { Button, SearchField, Quantity } from 'views/components';
import { toast } from 'react-toastify';
import ProductCatalog from './product-catalog';

export const focusPosProductSearch = () => {
  const input = (document.getElementById('posProductSearchInput') ||
    document.querySelector('.search-input input[name="q"]') ||
    document.querySelector('input[name="q"]')) as HTMLInputElement | null;
  if (input) {
    input.focus();
    input.select();
    return true;
  }
  return false;
};

const SearchAndModel = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { cart } = useSelector((state: _Object) => state.cart);
  const { me } = useSelector((state: _Object) => state.session);

  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState<_Object>({
    search: false,
    summary: false,
    discountbtn: false,
  });
  const [modalState, setModalState] = useState(false);
  const [querySearch, setQuerySearch] = useState(false);
  console.log(querySearch);
  const [checkProducts, setCheckProducts] = useState<_Object>({ item: [] });

  useEffect(() => {
    const localdata: any = localStorage.getItem('cartLineItems');
    if (JSON.parse(localdata)?.length > 0 && cart?.lineItems?.length === 0) {
      dispatch(addToCart(JSON.parse(localdata)));
    }
  }, []);

  useEffect(() => {
    if ((location.state as any)?.focusProductSearch) {
      const timer = setTimeout(() => {
        focusPosProductSearch();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  const handleShow = () => {
    setModalState(!modalState);
    setProducts([]);
    setCheckProducts({ item: [] });
  };

  const formik = useFormik({
    initialValues: { q: '' },
    enableReinitialize: true,
    onSubmit: () => {
      if (formik.values.q.trim() !== '') {
        getProducts();
      }
    },
  });

  const getProducts = () => {
    setLoading({ search: true });
    if (formik.values.q) {
      productService
        .getProducts({ q: formik.values.q.trim(), is_sale_enabled: true })
        .then((data: _Object) => {
          setQuerySearch(true);
          setLoading({ search: false });
          const items = data?.items || [];

          if (items.length === 0) {
            toast.error(`${t('common.productNotFound')}`, { autoClose: 3000 });
          } else if (items.length === 1) {
            setProducts(items);
            if (items[0]?.stock_status === 'outofstock') {
              toast.error('This product is currently out of stock', {
                autoClose: 3000,
              });
            } else {
              dispatch(
                addToCart({
                  id: items[0]?.id,
                  sku: items[0]?.sku,
                  name: items[0]?.name,
                  stock: items[0]?.stock_status,
                  price: items[0]?.discounted_price
                    ? items[0]?.discounted_price
                    : items[0]?.regular_price,
                  regular_price: items[0]?.regular_price,
                  tax_rate: items[0]?.tax?.rate || items[0]?.tax_rate || 0,
                  tax:
                    items[0]?.tax ||
                    (items[0]?.tax_rate ? { rate: items[0]?.tax_rate } : null),
                  brand_name: items[0]?.brand?.name,
                  tax_rate_id: items[0]?.tax_rate_id,
                  description: items[0]?.description,
                  image: items[0]?.image || items[0]?.thumbnail || '',
                  initials: items[0]?.initials || '',
                }),
              );
            }
            formik.setFieldValue('q', '');
          } else {
            // All products matching keyword -> open modal with all items!
            const updatedProducts = items.map((item: any) => {
              const newQuantity = item?.quantity ? item?.quantity : 1;
              return {
                ...item,
                quantity: newQuantity,
                price: item.discounted_price
                  ? item.discounted_price
                  : item.regular_price,
                image: item?.image || item?.thumbnail || '',
                initials: item?.initials || '',
              };
            });
            handleShow();
            setProducts(updatedProducts);
          }
        })
        .catch(() => {
          setLoading({ search: false });
          toast.error(`${t('common.productNotFound')}`, { autoClose: 3000 });
        });
    }
  };

  const handleCheckBox = (e: any, item: any) => {
    if (e.target.checked) {
      setCheckProducts((prev: any) => ({
        ...prev,
        item: [
          ...prev.item,
          {
            ...item,
            price: item.discounted_price
              ? item.discounted_price
              : item.regular_price,
            regular_price: item.regular_price,
            tax_rate: item.tax?.rate || item.tax_rate || 0,
            tax: item.tax || (item.tax_rate ? { rate: item.tax_rate } : null),
            image: item?.image || item?.thumbnail || '',
            initials: item?.initials || '',
          },
        ],
      }));
    } else {
      const filterData = checkProducts?.item?.filter(
        (data: any) => data?.id !== item?.id,
      );
      const updatedItem = filterData.map((data: any) => ({
        ...data,
        price: data.discounted_price
          ? data.discounted_price
          : data.regular_price,
      }));

      setCheckProducts({ item: updatedItem });
    }
  };

  const updateCheckedProductQty = (item: any, quantity: number) => {
    const filterData = checkProducts?.item?.filter(
      (data: any) => data?.id !== item?.id,
    );
    const findItem = checkProducts?.item?.find(
      (data: any) => data?.id === item?.id,
    );

    if (findItem) {
      setCheckProducts({
        item: [
          ...filterData,
          {
            ...findItem,
            price: findItem.discounted_price
              ? findItem.discounted_price
              : findItem.regular_price,
            regular_price: findItem.regular_price,
            tax_rate: findItem.tax?.rate || findItem.tax_rate || 0,
            tax:
              findItem.tax ||
              (findItem.tax_rate ? { rate: findItem.tax_rate } : null),
            quantity: quantity,
          },
        ],
      });
    }
  };

  return (
    <div className="pos-search-and-catalog-wrapper d-flex flex-column flex-grow-1 h-100 overflow-hidden">
      <form
        onSubmit={formik.handleSubmit}
        className={`form-loading flex-shrink-0 ${loading.search === true ? 'btn-loading' : ''}`}
      >
        <SearchField
          id="posProductSearchInput"
          name="q"
          disabled={!formik.values.q}
          autoFocus
          type="search"
          autoComplete="off"
          value={formik.values.q}
          onChange={(e: _Object) => {
            if (!e.target.value) {
              setProducts([]);
            }
            setQuerySearch(false);
            formik.setFieldValue('q', e.target.value);
          }}
        />
      </form>

      {me?.client?.pos_system_type !== 3 && (
        <ProductCatalog searchQuery={formik.values.q} />
      )}

      {/* Search modal - Displays all keyword-based matching products */}
      {formik?.values?.q && products?.length > 1 && (
        <div
          className={`modal fade ${modalState ? ' show d-block' : ' d-none'}`}
          id="exampleModal"
          role="dialog"
          aria-hidden="true"
          style={{
            backgroundColor: modalState ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="mb-0">{t('common.search_result')}</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleShow}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div
                className="table-responsive-md overflow-auto"
                style={{ maxHeight: '72vh' }}
              >
                <table className="table table-borderless sales-table table-striped order-listing w-100">
                  <thead className="sticky-top">
                    <tr>
                      <th>{t('common.item')}</th>
                      <th style={{ width: '120px' }}>{t('common.price')}</th>
                      <th style={{ width: '160px' }}>{t('common.quantity')}</th>
                      <th className="text-end" style={{ width: '50px' }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {products?.map((item: any, i: number) => {
                      const isChecked = Boolean(
                        checkProducts?.item?.some(
                          (ci: any) => ci?.id === item?.id,
                        ),
                      );
                      return (
                        <tr key={item.id || i}>
                          <td className="break-spaces">
                            {capitalizeFirstLetter(item?.name)}
                            {item.size && item.color && (
                              <>
                                <span className="d-block text-secondary">
                                  {t('checkout.size')}:
                                </span>
                                <span className="d-block text-secondary">
                                  {t('checkout.colour')}:
                                </span>
                              </>
                            )}
                            <small className="d-block text-secondary">
                              {t('common.sku')}: {item?.sku}
                            </small>
                          </td>
                          <td>
                            {doAmountFormat(
                              item.discounted_price
                                ? item.discounted_price
                                : item.regular_price || item.price,
                            )}
                            {item?.tax_rate?.rate && (
                              <small className="d-block text-secondary">{`${
                                item?.tax_rate?.name ||
                                item.tax_rate?.title?.toUpperCase()
                              } ${item?.tax_rate?.rate}%`}</small>
                            )}
                          </td>
                          <td>
                            <Quantity
                              id={`qty-${item.id}`}
                              onChange={(e: _Object) =>
                                dispatch(
                                  setQuantity({
                                    quantity: e.target.value,
                                    id: item.id,
                                  }),
                                )
                              }
                              value={item.quantity}
                              incrementQuantity={() => {
                                item.quantity = (item.quantity || 1) + 1;
                                updateInputFieldValue(
                                  `qty-${item.id}`,
                                  item.quantity,
                                );
                                updateCheckedProductQty(item, item.quantity);
                              }}
                              decrementQuantity={() => {
                                if ((item.quantity || 1) > 1) {
                                  item.quantity -= 1;
                                  updateInputFieldValue(
                                    `qty-${item.id}`,
                                    item.quantity,
                                  );
                                  updateCheckedProductQty(item, item.quantity);
                                }
                              }}
                            />
                          </td>

                          <td className="text-center">
                            <input
                              className="form-check-input mt-0"
                              type="checkbox"
                              aria-label="Checkbox for following text input"
                              checked={isChecked}
                              onChange={(e: any) => handleCheckBox(e, item)}
                              disabled={item.stock_status === 'outofstock'}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="modal-footer">
                <Button
                  type="button"
                  className="link text-danger text-decoration-underline"
                  onClick={handleShow}
                >
                  {t('common.cancel')}
                </Button>

                <Button
                  type="button"
                  className="primary"
                  disabled={checkProducts?.item?.length === 0}
                  loading={loading.search}
                  onClick={() => {
                    dispatch(addToCart(checkProducts.item));
                    formik.setFieldValue('q', '');
                    setCheckProducts({ item: [] });
                    setProducts([]);
                    setModalState(false);
                  }}
                >
                  {t('checkout.add_to_cart')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchAndModel;
